import React, {Component} from 'react';
import '../css/index.css';
import '../../node_modules/font-awesome/css/font-awesome.min.css';
import Table from '../components/Table'
import Slider from '../components/Slider';

class ExhibitionDesktop extends Component
{
  constructor(props) {
    super(props)
    this.state = {
      data: [],
    }
    this.handleCurrentSlide = this.handleCurrentSlide.bind(this);
  }

  componentWillMount() {
    var arr = [];
    var list = [];
    var chunk_size = 6;
    var currentSlide = 0;
    var thisState = this;
    fetch('/api/getartwork', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({exhibition_name : this.props.art})
    }).then((resp) => resp.json())
    .then(function(data) {
      arr = Object.keys(data.art).map(function(obj) {
        return data.art[obj];
      });
      var artworkCount = Object.keys(data.art).length;
      if (artworkCount % 6 !== 0) {
        if (artworkCount <= 6) {
          var val = 6 - artworkCount;
          for (var i = 0; i < val; i++) {
            arr.push({
                "painting_oid": "empty",
                "artwork_name": "",
                "artwork_description":"",
                "video_url": "",
                "video_id": "",
                "artwork_status": "",
                "paintings": "/empty.jpg"
            })
          }
        }
        else {
          val = 6 - Math.floor(artworkCount%6);
          for (i = 0; i < val; i++) {
            arr.push({
                "painting_oid": "empty",
                "artwork_name": "",
                "artwork_description":"",
                "video_url": "",
                "video_id": "",
                "artwork_status": "",
                "paintings": "/empty.jpg"
            })
          }
        }
    }
    var k = 0;
    for (i=0; i<arr.length; i+=6) {
        list.push(
          <div key={i}>
              <Table
                index={k}
                array={arr.slice(i,i+chunk_size)}
                />
          </div>
            );
        k++;
      }
    thisState.setState({ data: list })
    });
  }

  handleCurrentSlide(event) {
    this.setState({ currentSlide: event })
  }

  render() {
      return (
          <div className="slider-exhibition">
                <Slider loop={true} selected={this.props.currentSlide} showNav={ this.state.data.length > 1 ? true: false }>
                    { this.state.data }
                </Slider>
          </div>
      );
    }
}
export default ExhibitionDesktop;



// WEBPACK FOOTER //
// ./src/pages/ExhibitionDesktop.js